
import { motion } from 'framer-motion'
import { MapPin, ChevronRight } from 'lucide-react'
import { Button, ButtonVariant } from '@meiuca/ui-components'
import { useNavigate } from 'react-router-dom'

interface LocationRequiredEmptyStateProps {
  title?: string
  description?: string
  buttonText?: string
  onLocationSelect?: () => void
}

export function LocationRequiredEmptyState({
  title = "Localização necessária",
  description = "Para buscar jogos próximos a você, é necessário selecionar sua localização.",
  buttonText = "Selecionar localização",
  onLocationSelect
}: LocationRequiredEmptyStateProps) {
  const navigate = useNavigate()

  const handleLocationSelect = () => {
    if (onLocationSelect) {
      onLocationSelect()
    } else {
      navigate('/app/settings/location')
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center py-16 px-6 text-center bg-background-white rounded-xl border border-border-primary"
    >
      <div className="w-20 h-20 bg-brand-primary/10 rounded-full flex items-center justify-center mb-6">
        <MapPin className="w-10 h-10 text-brand-primary" />
      </div>
      
      <h2 className="text-xl font-semibold text-text-primary mb-3">
        {title}
      </h2>
      
      <p className="text-text-secondary mb-8 max-w-md leading-relaxed">
        {description}
      </p>
      
      <Button 
        variant={ButtonVariant.PRIMARY}
        onClick={handleLocationSelect}
        className="flex items-center space-x-2"
      >
        <MapPin className="w-5 h-5" />
        <span>{buttonText}</span>
        <ChevronRight className="w-4 h-4" />
      </Button>
    </motion.div>
  )
}